import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

// Interface that must be implemented for deactivation check
export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
  canDeactivate(component: any): Observable<boolean> | Promise<boolean> | boolean {
    // Only check components that implement CanComponentDeactivate
    if ('canDeactivate' in component) {
      return component.canDeactivate();
    }
    return true; // Allow navigation if the component does not implement canDeactivate
  }
}
